<div class="tw-flex tw-items-start tw-gap-1 tw-bg-orange-75 tw-px-4 tw-py-4"
     (click)="onClick()">
  <!-- Refresh / retake icon -->
  <cs-icon class="tw-h-6 tw-w-6 tw-shrink-0 tw-text-gray-800 -tw-mt-0.5" [iconName]="'reload_reverse'"></cs-icon>

  <div class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col tw-items-start">
    <div class="tw-flex tw-w-full tw-items-center tw-justify-between tw-gap-2">
      @if (isFaceRegimen()) {
        <p class="tw-font-lexend tw-text-300 tw-font-bold tw-text-gray-800" i18n="@@retakeSkinTest">Retake Skin Test</p>
      } @else {
        <p class="tw-font-lexend tw-text-300 tw-font-bold tw-text-gray-800" i18n="@@retakeHairTest">Retake Hair Test</p>
      }
      <!-- Chevron inside teal circle -->
      <span class="tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded-full tw-bg-teal-600">
        <cs-icon class="tw-w-1 tw-text-white" [iconName]="'chevron_forward'"></cs-icon>
      </span>
    </div>
    <p class="tw-font-body tw-text-200 tw-text-gray-500 tw-w-[65%] tw-mt-0.5" i18n="@@reanswerQuestionsHint">If you missed any detail, you can re-answer the questions</p>
  </div>
</div>
